import { useEffect } from 'react'
import { BookingFormattedInfo, IBookingInfo } from '../types'
import { parseISO } from 'libs/dates'

type UsePopulateCalendarProps = {
	data: any
	setItems: any
}

export const usePopulateCalendar = ({ data, setItems }: UsePopulateCalendarProps) => {
	useEffect(() => {
		if (Array.isArray(data)) {
			const formattedData = data?.reduce((total: BookingFormattedInfo[], current: IBookingInfo) => {
				return [
					...total,
					{
						id: current.id,
						title: 'start',
						date: parseISO(current.start_date),
						ref: current.ref_nr,
						start_date: current.start_date,
						end_date: current.end_date,
						name: current.booth?.booth_type?.name
							? `${current.booth?.booth_type?.name} - #${current.booth?.number}`
							: '-',
						user: current.user.name ? current.user.name : current.user.email,
						boothNumber: current.booth?.number && `#${current.booth?.number}`,
						boothType: current.booth?.booth_type?.name,
						takedownRequested: current.takedown_requested,
						overdue: !!current.overdue,
						completed: !!current.completed,
						status: current.status
					},
					{
						id: current.id,
						title: 'end',
						date: current.end_date ? parseISO(current.end_date) : null,
						ref: current.ref_nr,
						start_date: current.start_date,
						end_date: current.end_date,
						name: current.booth?.booth_type?.name
							? `${current.booth?.booth_type?.name} - #${current.booth?.number}`
							: '-',
						user: current.user.name ? current.user.name : current.user.email,
						boothNumber: current.booth?.number && `#${current.booth?.number}`,
						boothType: current.booth?.booth_type?.name,
						takedownRequested: current.takedown_requested,
						overdue: !!current.overdue,
						completed: !!current.completed,
						status: current.status
					}
				]
			}, []) as BookingFormattedInfo[]

			setItems(formattedData)
		}
	}, [data])
}
